import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col, Carousel, Modal } from 'antd'
import '../../../css/patient.scss'
import _, { set } from 'lodash'
import { useParams } from 'react-router-dom'
import {
  getOksData,
  getPainData,
  getFlexionData,
  getExtensionData,
  getFormData,
} from '../../../store/action/patient.action'
import Oks from './oks'
import HoosJr from './hoosjr'
import Pain from './pain'
import Flexion from './flexion'
import Extension from './extension'
import { RightCircleFilled, LeftCircleFilled } from '@ant-design/icons'

const MODAL_TYPE = {
  OKS: 'OKS',
  KOOSJR: 'KOOSJR',
  HOOSJR: 'HOOSJR',
  PAIN: 'PAIN',
  FLEXION: 'FLEXION',
  EXTENSION: 'EXTENSION',
}

const PatientForms = (props) => {
  // const [oks, setOks] = useState([]);
  // const [flexion, setFlexion] = useState([]);
  // const [extension, setExtension] = useState([]);
  const [state, setState] = useState({
    oks: [],
    hoosJr: [],
    pain: [],
    flexion: [],
    extension: [],
  })
  const [modal, setModal] = useState(false)

  var params = useParams()
  var ref = useRef(null)

  useEffect(() => {
    getData(params.id)
  }, [])

  var getData = async (id) => {
    var data = await props.getFormData(id)
    setState({
      oks: data?.oks,
      hoosJr: data?.hoosJr,
      pain: data?.pain,
      flexion: data?.flexion,
      extension: data?.extension,
    })
  }

  var handleNextClick = (e) => ref.current.next()
  var handlePrevClick = (e) => ref.current.prev()

  var handleModalOpen = (e) => setModal(e)

  const contentStyle = {
    height: '350px',
    color: '#fff',
    lineHeight: '160px',
    textAlign: 'center',
    background: '#364d79',
  }

  var renderBody = () => {
    switch (modal) {
      case MODAL_TYPE.OKS:
        return <Oks data={state.oks} fullscreen showtips />
      case MODAL_TYPE.HOOSJR:
        return <HoosJr data={state.hoosJr} fullscreen showtips />
      case MODAL_TYPE.PAIN:
        return <Pain data={state.pain} fullscreen showtips />
      case MODAL_TYPE.FLEXION:
        return <Flexion data={state.flexion} fullscreen showtips />
      case MODAL_TYPE.EXTENSION:
        return <Extension data={state.extension} fullscreen showtips />
      default:
        return null
    }
  }

  return (
    <>
      <Row style={{ width: '100%' }} justify='center' align='middle'>
        <Col span={2}>
          <LeftCircleFilled onClick={handlePrevClick} />
        </Col>
        <Col span={20}>
          <Carousel ref={ref} dots={false}>
            <div className='chartContainer' style={contentStyle}>
              <Oks
                data={state.oks}
                onClick={handleModalOpen}
                fullscreen={!props.modal}
                showtips
              />
            </div>
            <div className='chartContainer' style={contentStyle}>
              <Pain
                data={state.pain}
                onClick={handleModalOpen}
                fullscreen={!props.modal}
                showtips
              />
            </div>
            <div className='chartContainer' style={contentStyle}>
              <Flexion
                data={state.flexion}
                onClick={handleModalOpen}
                fullscreen={!props.modal}
                showtips
              />
            </div>
            <div className='chartContainer' style={contentStyle}>
              <Extension
                data={state.extension}
                onClick={handleModalOpen}
                fullscreen={!props.modal}
                showtips
              />
            </div>
          </Carousel>
        </Col>
        <Col span={2} align={'right'}>
          <RightCircleFilled onClick={handleNextClick} />
        </Col>
      </Row>
      <Modal
        visible={modal && props.modal}
        footer={false}
        onCancel={() => setModal(false)}
      >
        {renderBody()}
      </Modal>
    </>
  )
}

PatientForms.propTypes = {
  patient: PropTypes.object,
  getReport: PropTypes.func,
}

const mapStateToProps = (state) => {
  return {
    patient: state.patient.patient,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getOksData: (id) => dispatch(getOksData(id)),
    getPainData: (id) => dispatch(getPainData(id)),
    getFlexionData: (id) => dispatch(getFlexionData(id)),
    getExtensionData: (id) => dispatch(getExtensionData(id)),
    getFormData: (id) => dispatch(getFormData(id)),
  }
}

export { MODAL_TYPE }
export default connect(mapStateToProps, mapDispatchToProps)(PatientForms)
